import {
  EDIT_PERSONALIZED_CONFIG_OPTIONS_LOADING,
  EDIT_PERSONALIZED_CONFIG_OPTIONS_SUCCESS,
  EDIT_PERSONALIZED_CONFIG_OPTIONS_ERROR,
  FETCH_PERSONALIZED_CONFIG_OPTIONS_LOADING,
  FETCH_PERSONALIZED_CONFIG_OPTIONS_SUCCESS,
  FETCH_PERSONALIZED_CONFIG_OPTIONS_ERROR,
  SET_PERSONALIZED_CONFIG_OPTION,
  EDIT_WORKLOAD_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_LOADING,
  EDIT_WORKLOAD_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_SUCCESS,
  EDIT_WORKLOAD_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_ERROR,
  EDIT_TIMESHEET_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_LOADING,
  EDIT_TIMESHEET_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_SUCCESS,
  EDIT_TIMESHEET_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_ERROR,
  EDIT_TIME_DASHBOARD_INTERVAL_PERSONALIZED_CONFIG_OPTIONS_LOADING,
  EDIT_TIME_DASHBOARD_INTERVAL_PERSONALIZED_CONFIG_OPTIONS_SUCCESS,
  EDIT_TIME_DASHBOARD_INTERVAL_PERSONALIZED_CONFIG_OPTIONS_ERROR,
} from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";
import { encodeData } from "~/utils/utils.jsx";

export const fetchPersonalizedConfigOptions = (...options) => {
  const query = encodeData({ names: options.join(`,`) });
  const url = `${Angie.api_url}/personalized-config-options?${query}`;

  return {
    types: [
      FETCH_PERSONALIZED_CONFIG_OPTIONS_LOADING,
      FETCH_PERSONALIZED_CONFIG_OPTIONS_SUCCESS,
      FETCH_PERSONALIZED_CONFIG_OPTIONS_ERROR,
    ],
    callAPI: () => fetch({ url }),
    payload: { options },
    cache: { key: url },
  };
};

export const setPersonalizedConfigOption = (name, value) => {
  return {
    type: SET_PERSONALIZED_CONFIG_OPTION,
    name,
    value,
  };
};

export const editPersonalizedConfigOptions = (options, signal) => {
  return {
    types: [
      EDIT_PERSONALIZED_CONFIG_OPTIONS_LOADING,
      EDIT_PERSONALIZED_CONFIG_OPTIONS_SUCCESS,
      EDIT_PERSONALIZED_CONFIG_OPTIONS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/personalized-config-options`,
        method: `put`,
        body: options,
        signal,
      }),
    payload: { options },
  };
};

export const editTimeDashboardIntervalPersonalizedConfigOptions = (value, signal) => {
  return {
    types: [
      EDIT_TIME_DASHBOARD_INTERVAL_PERSONALIZED_CONFIG_OPTIONS_LOADING,
      EDIT_TIME_DASHBOARD_INTERVAL_PERSONALIZED_CONFIG_OPTIONS_SUCCESS,
      EDIT_TIME_DASHBOARD_INTERVAL_PERSONALIZED_CONFIG_OPTIONS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/personalized-config-options`,
        method: `put`,
        body: { time_dashboard_interval: value },
        signal,
      }),
    payload: { options: { time_dashboard_interval: value } },
  };
};

export const editWorkloadPeoplePickerPersonalizedConfigOption = (value) => {
  const action = editPersonalizedConfigOptions({
    workload_people_picker: value,
  });

  return {
    ...action,
    types: [
      EDIT_WORKLOAD_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_LOADING,
      EDIT_WORKLOAD_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_SUCCESS,
      EDIT_WORKLOAD_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_ERROR,
    ],
  };
};

export const editTimesheetPeoplePickerPersonalizedConfigOption = (value) => {
  const action = editPersonalizedConfigOptions({
    timesheet_people_picker: value,
  });

  return {
    ...action,
    types: [
      EDIT_TIMESHEET_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_LOADING,
      EDIT_TIMESHEET_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_SUCCESS,
      EDIT_TIMESHEET_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_ERROR,
    ],
  };
};
